import AccountSecurity from './AccountSecurity'

export default AccountSecurity
// eslint-disable-next-line import/export
export * from './AccountSecurity'
